import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <main className="home section">
      <div className="container">
        <p className="home-label">Hi, I'm</p>
        <h1 className="home-title">Adyant Khanna</h1>
        <p className="home-tagline">
          Product Manager at Roblox on Payments and Developer Monetization.
        </p>
        <p className="home-bio">
          I'm interested in how people build and earn on platforms, how AI and ML shape products, and in physical AI — robotics and systems that interact with the real world.
        </p>
        <nav className="home-links">
          <Link to="/experience">Experience</Link>
          <Link to="/writing">Writing</Link>
        </nav>
      </div>
    </main>
  );
}

export default Home;
